import queryString from 'query-string';
import { pickBy, isEqual } from 'lodash';
import { Location } from 'history';
import { Schema } from './parts/SearchForm';
import { UsersQueryVariables, SortColumn, SortOrder } from './query';

export interface SearchParams {
  _page?: string;
  limit?: string;
  sort_type?: string;
}

export const defaultSearchParams = {
  _page: '1',
  sort_type: 'staff_code__asc'
} satisfies SearchParams;

export const getSearchParamsFromLocation = (location: Location): SearchParams => {
  return {
    ...defaultSearchParams,
    ...queryString.parse(location.search, { arrayFormat: 'bracket' })
  };
};

export const convertSearchParamsToQueryString = (params: SearchParams): string =>
  queryString.stringify(params, { arrayFormat: 'bracket' });

export const convertSearchParamsToForm = (params: SearchParams): Schema => {
  return {
    page: params._page || '1',
    limit: params.limit || '100',
    sortType: params.sort_type || defaultSearchParams.sort_type
  };
};

export const convertFormToSearchParams = (form: Schema): SearchParams => {
  return pickBy({
    _page: form.page,
    limit: undefined,
    sort_type: form.sortType
  });
};

export const convertSearchParamsToGraphQL = (params: SearchParams): UsersQueryVariables => {
  const [sortColumn, sortOrder] = (params.sort_type || defaultSearchParams.sort_type).split('__');
  return {
    page: Number(params._page) || 1,
    limit: Number(params.limit) || 100,
    search: {
      sortColumn: sortColumn as SortColumn,
      sortOrder: sortOrder as SortOrder
    }
  };
};

export const hasConditions = (form: Schema): boolean => {
  return !isEqual(
    pickBy(convertFormToSearchParams(form), v => (Array.isArray(v) ? v.length > 0 : v)),
    defaultSearchParams
  );
};
